import { memo } from 'react';

import { MoonIcon, SunIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { useAssetModalThemeToggle } from '~/components/v2/components/asset-modal/hooks/useAssetModalThemeToggle';
import { Theme } from '~/components/v2/store/shared/createThemeSlice';

export const AssetModalContentFooterThemeToggleButton = memo(() => {
  const { onToggleTheme, theme, themeLabel } = useAssetModalThemeToggle();

  return (
    <Tooltip label={themeLabel}>
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        data-testid="THEME_TOGGLE_BUTTON"
        icon={theme === Theme.Dark ? SunIcon : MoonIcon}
        label={themeLabel}
        size="medium"
        onClick={onToggleTheme}
      />
    </Tooltip>
  );
});

AssetModalContentFooterThemeToggleButton.displayName = 'AssetModalContentFooterThemeToggleButton';
